import Vue from 'vue'

function companyIdFromKey(key) {
  if (key && key.startsWith('companies/')) {
    return key.split('/')[1]
  }
  return null
}

export default {
  namespaced: true,
  state: {},
  actions: {
    async getObject({ rootGetters }, { key }) {
      const companyId = companyIdFromKey(key) || rootGetters['company/selectActiveCompany']?._id
      const { body } = await Vue.http.post('app-services/v2/media/download-url', {
        key,
        companyId
      })
      const response = await window.fetch(body.data.url)
      if (!response.ok) {
        throw new Error(`Failed to fetch media: ${response.status}`)
      }
      const contentType = response.headers.get('content-type')
      const arrayBuffer = await response.arrayBuffer()
      const base64 = btoa(
        new Uint8Array(arrayBuffer).reduce((data, byte) => data + String.fromCharCode(byte), '')
      )
      return { ContentType: contentType, base64 }
    },
    async uploadFile({ rootGetters }, { Key, Body, ContentType }) {
      const companyId = companyIdFromKey(Key) || rootGetters['company/selectActiveCompany']?._id
      const { body } = await Vue.http.post('app-services/v2/media/upload-url', {
        key: Key,
        contentType: ContentType,
        contentLength: Body.size,
        companyId
      })
      const presignedUrl = body.data.url
      const uploadResponse = await window.fetch(presignedUrl, {
        method: 'PUT',
        headers: { 'Content-Type': ContentType },
        body: Body
      })
      if (!uploadResponse.ok) {
        throw new Error(`S3 upload failed: ${uploadResponse.status}`)
      }
      return { Location: presignedUrl.split('?')[0], Key }
    }
  }
}
